export default {
  age2: 'Age2',
  time2: 'Time2',
}